import ReactDOM from 'react-dom/client';
import App from './App';
import { resolveEnv } from './environment';
import { BootService } from './services/boot';

const env = resolveEnv();

function mount(): void {
  const html = document.getElementById('app');
  if (!html) {
    throw new Error('Root element not found');
  }
  const root = ReactDOM.createRoot(html);
  root.render(<App wcconfig={{ env }} />);
}

BootService.init(env);
mount();
